import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTheme, buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import ProfileSubpage from 'Views/Page/Content/Templates/Profile/Templates/ProfileSubpage';
import fr from 'facet-rest';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import PersonalFamilyInformation from 'Components/ClientApp/CombinedApp/Viewport/Profile/PersonalFamilyInformation';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { root } from 'Views/Page/Content/Templates/Profile/Templates/ProfileTemplate/Subpages/subpageClasses';

const useStyles = buildUseStyles('TemporaryPersonalAndFamilySubpage', (theme) => ({
  root: root(theme),
  container: {
    width: '100%',
    margin: theme.spacing(6, 0),
  },
}));

const TemporaryPersonalAndFamilySubpage = ({
  className,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const { householdResource } = useSimpleHousehold();
  const profilePageRelationship = householdResource?.relationship(fr.relationships.householdMembershipPage.name).link('related');

  return (
    <ProfileSubpage
      className={classNames(classes.root, className)}
      title={'Manage Family Members'}
      description={'Manage your own and your family members stored information.'}
      backLink={profilePageRelationship}
    >
      <Box className={classes.container} test={'profile-page-members-manage'}>
        <PersonalFamilyInformation />
      </Box>
    </ProfileSubpage>
  );
};

TemporaryPersonalAndFamilySubpage.defaultProps = {
  className: '',
};

TemporaryPersonalAndFamilySubpage.propTypes = {
  className: PropTypes.string,
};

export default TemporaryPersonalAndFamilySubpage;
